/**
 * Values of the `engine` Sentry tag. Must stay identical to the ENGINE_* constants on the
 * api-core Company model — Sentry saved searches and alert rules match these strings across
 * both the talk2-web and aloware-core projects, so a drift silently splits the results in two.
 */
export const ENGINES = {
  TASK_ROUTER: 'task_router',
  MIGRATING: 'migrating',
  LEGACY: 'legacy'
}

export const TASK_ROUTER_SETUP_STATUS_SETTING_UP = 'setting_up'

/**
 * Which telephony engine a company routes on, as a Sentry tag value.
 *
 * Three states rather than a boolean: use_new_engine only flips true once api-core finishes
 * provisioning the company's TaskRouter workers and queues, so a company mid-onboarding still
 * reads false. Folding that window into LEGACY would hide the errors of a rollout under the
 * engine the company is leaving.
 *
 * @param {object} company - The currentCompany payload from GET /api/v1/company/{id}
 * @returns {string} One of ENGINES
 */
export function engineTag (company) {
  if (!company) {
    return ENGINES.LEGACY
  }

  if (company.use_new_engine) {
    return ENGINES.TASK_ROUTER
  }

  if (company.task_router_setup_status === TASK_ROUTER_SETUP_STATUS_SETTING_UP) {
    return ENGINES.MIGRATING
  }

  return ENGINES.LEGACY
}
